<template>
    <div>
        <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="理论考试成绩">
                <div style="width: 30%;display: flex;margin-left: 20px">
                    <el-input v-model="value"
                              style="width: 50%;"
                              placeholder="请输入学号"
                              :fetch-suggestions="querySearchAsync"
                              @select="handleSelect">
                    </el-input>
                    <el-button @click="search">搜索</el-button>
                </div>

                <el-table
                        :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                        stripe ref="multipleTable"
                        tooltip-effect="dark"
                        border
                        style="width: 100%;margin-top: 30px">
                    <el-table-column
                            type="index"
                            align="center"
                            label="序号"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="createBy"
                            align="center"
                            label="学号">
                    </el-table-column>
                    <el-table-column
                            prop="createUserName"
                            align="center"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            prop="score"
                            label="分数"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="提交时间"
                            align="center">
                        <template slot-scope="scope">
                            <span>{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page" style="margin-top: 30px;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length">
                    </el-pagination>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="实验报告记录" force-render>
                <div style="width: 30%;display: flex;margin-left: 20px">
                    <el-input v-model="value"
                              style="width: 50%;"
                              placeholder="请输入学号"
                              :fetch-suggestions="querySearchAsync"
                              @select="handleSelect">
                    </el-input>
                    <el-button @click="searchsy">搜索</el-button>
                </div>
                <el-table
                        :data="sydata.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                        stripe ref="multipleTable"
                        tooltip-effect="dark"
                        border
                        style="width: 100%;margin-top: 30px">
                    <el-table-column
                            type="index"
                            align="center"
                            label="序号"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="createBy"
                            align="center"
                            label="学号">
                    </el-table-column>
                    <el-table-column
                            prop="createUserName"
                            align="center"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            prop="score"
                            label="分数"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="提交时间"
                            align="center">
                        <template slot-scope="scope">
                            <span>{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page" style="margin-top: 30px;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="sydata.length">
                    </el-pagination>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Table,TableColumn} from "element-ui";
    Vue.use(Table);
    Vue.use(TableColumn);
    export default {
        name: "Scoremanagement",
        data() {
            return {
                currentIndex: '',
                currentPage: 1, //初始页
                pagesize: 10, //    每页的数据
                tableData: [],
                data: [],
                sydata:[],
                mydata: [],
                value:''
            }
        },
        methods: {
            handleSizeChange: function(size) {
                this.pagesize = size;
                // console.log(this.pagesize) //每页下拉显示数据
            },
            handleCurrentChange: function(currentPage) {
                console.log(currentPage)
                this.currentPage = currentPage;
                this.getSoftwareScore()
                // console.log(this.currentPage) //点击第几页
            },
            callback(key) {
                console.log(key);
            },
            // currentchange(val){
            //     console.log(val);
            //     this.Pagination.pageNo = val;
            //     this.getSoftwareScore();
            // },
            getSoftwareScore() {
                let url = '/score/list/'+(this.currentPage -1);

                this.$axios.get(url).then((resp) => {
                    var content = resp.data.result.content;
                    console.log('实验',content);
                    if (content.type = "null"){
                        this.sydata = resp.data.result.content;
                    }
                        this.total = resp.data.result.totalElements
                })
            },
            getlist() {
                let url = '/score/list/0?type=1'+(this.currentPage -1);
                this.$axios.get(url).then((resp) => {
                    var content = resp.data.result.content;
                    console.log('chengji',content);
                    if (resp.data.success) {
                        this.data = resp.data.result.content;
                        // var newData = [];
                        // var p = false;
                        // this.data.forEach(data => {
                        //     newData.forEach(res => {
                        //         if (res.createBy === data.createBy) {
                        //             p = true;
                        //         }
                        //         if (res.createBy !== data.createBy) {
                        //             p = false;
                        //         }
                        //     })
                        //     if (p === false) {
                        //         newData.push(data)
                        //     }
                        //
                        // })
                        // this.data = newData
                        this.total = resp.data.result.totalElements
                    }

                })
            },

            handleSelect(){

            },
            querySearchAsync(){

            },
            //理论题搜索查询
            search(){
                // let params ={
                //
                // }
                let url = '/score/list/0?type=1&createBy='+ (this.value);
                this.$axios.get(url).then((resp) => {
                    if(resp.data.success){
                        this.data = resp.data.result.content;
                    } else {
                        this.$message.error('操作失败')
                    }
                })

            },
            // 实验题搜索
            searchsy(){
                let url = '/score/list/0?createBy='+ (this.value);
                this.$axios.get(url).then((resp) => {
                    if(resp.data.success){
                        this.sydata = resp.data.result.content;
                    } else {
                        this.$message.error('操作失败')
                    }
                })
            }
        },
        mounted() {
            this.getlist()
            this.getSoftwareScore()
        }
    }
</script>

<style scoped>

</style>
